import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list",
  "use": "icon-list-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-list\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M8,5.5H21v3H8Zm-5,0H6v3H3Zm0,5H6v3H3Zm0,5H6v3H3Zm5-5H21v3H8Zm0,5H21v3H8Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol